// https://casesandberg.github.io/react-color/#getting-started

import React, { useEffect, useState,lazy } from 'react';
import { injectIntl } from 'react-intl';
//import { ChromePicker } from 'react-color';
import { cleanFieldProps, i18nIntl, parseClasses } from '../../lib/ep.js';
import { useCSS } from '../../lib/hooks.js';

import ActionButton, { SquaredButton } from './ActionButton';
import ButtonCollection from './ButtonCollection.js';
import FloatingLayer from './FloatingLayer';
import FieldWrapper from './FieldWrapper.js';
import SectionTitle from './SectionTitle';
import Tooltip from './Tooltip.js';
import Loadable from 'react-loadable';

const ChromePicker = Loadable({
	loader:() => import('./ColorPickerChrome.js'),
	loading:() => <div>Loading...</div>,
});

const ColorPicker = (props) => {
	useCSS('assets/color_picker.css');

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ background, setBackground ] = useState(props?.color ?? 'rgba(255, 255, 255, 1)');
	const [ visible, setVisible ] = useState(false);

	const enable_reset = props?.enable_reset ?? false;

	const label_color = props.children ? props.intl.formatMessage({ id:"Pick the {label}" }, { label:`"${i18n(props.children)}"` }) : i18n("Pick the color");

	useEffect(() => {
		setBackground(props?.color ?? 'rgba(255, 255, 255, 1)');
	}, [ props.color ]);

	const handleChangeComplete = (color) => {
		const rgba_code = `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`;
		setBackground(rgba_code);
		if(props.change) props.change(props.name, rgba_code);
	};

	const resetColor = (e) => {
		e.stopPropagation();
		if(props.change) props.change(props.name, null);
	};

	let classname = props?.classname ?? 'input gui_color_picker';
	classname = parseClasses(classname, props._class, 'colorpicker');

	const wrapper_props = cleanFieldProps(props);

	return (
		<FieldWrapper
			type='color'
			{...wrapper_props}
			onClick={() => setVisible(true)}
		>
			<div class="picker gui_bg_alpha_viewer">
				<a style={{ backgroundColor:background }} />
			</div>

			<ButtonCollection _class={{other:'floating_actions'}}>
				<SquaredButton
					icon='knk-information mainBgButton'
					tooltip={<Tooltip
						position="top"
						with_icon={false}
						autotranslate={false}
					>{background}</Tooltip>}
				/>

				<SquaredButton
					icon='knk-edit mainBgButton'
					onClick={() => setVisible(true)}
					tooltip={<Tooltip position="top" with_icon={false}>Edit color</Tooltip>}
					aria-label="Edit color"
				/>

				{(enable_reset) && (
					<SquaredButton
						icon='knk-off redIcon mainBgButton'
						onClick={resetColor}
						tooltip={<Tooltip position="top" with_icon={false}>Reset color</Tooltip>}
						aria-label="Reset color"
					/>
				)}
			</ButtonCollection>

			{(visible) && (
				<FloatingLayer _class={{ size:'small' }} backButton={() => setVisible(false)}>
					<div>
						<SectionTitle 
							autotranslate={false}
							>{label_color}</SectionTitle>

						<ChromePicker
							color={background}
							onChangeComplete={handleChangeComplete}
						/>

						<ButtonCollection in_floating={true}>
							<ActionButton
								stopPropagation={true}
								onClick={() => setVisible(false)}
							>Confirm</ActionButton>
						</ButtonCollection>
					</div>
				</FloatingLayer>
			)}
		</FieldWrapper>
	);
};

export default injectIntl(ColorPicker);